import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsService } from '../../services/permissions.service';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { OrganizationsService } from '../../services/organizations.service';
import { Organization } from '../../models/organization.model';
import { combineLatest, map, Observable, startWith, of } from 'rxjs';
import { OrganizationCardComponent } from '../organization-card/organization-card.component';
import { MatCardModule } from '@angular/material/card';
import { CommonModule, NgFor, NgForOf } from '@angular/common';

@Component({
    selector: 'app-organizations-list',
    standalone: true,
    imports: [
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        //MatTooltip,
        MatIconModule,
        OrganizationCardComponent,
        MatCardModule,
        NgFor,
        CommonModule
    ],
    templateUrl: './organizations-list.component.html',
    styleUrl: './organizations-list.component.css'
})
export class OrganizationsListComponent implements OnInit {

  public filter: FormControl = new FormControl('');
  public organizations$: Observable<Organization[]> = new Observable<Organization[]>();
  public filteredOrganizations$: Observable <Organization[]> = new Observable<Organization[]>;
  public filterValue$: Observable<string> = new Observable<string>();

  organizations: Organization[] = [];
  currentOrganization: Organization = new Organization(0, '', '', '');
  editForm: FormGroup = new FormGroup({});

  constructor(
    public router: Router,
    public permissionsService: PermissionsService,
    public organizationsService: OrganizationsService

  ) {

    this.organizations$ = of(this.organizations);
    this.filter = new FormControl('');
    this.filterValue$ = this.filter.valueChanges.pipe(startWith(''));

    this.filteredOrganizations$ = combineLatest([this.organizations$, this.filterValue$]).pipe(
      map(([organizations, filterValue]) => {
        return organizations.filter(organization => organization.name.toLowerCase().includes(filterValue.toLowerCase()))
      })
    );
  }

  ngOnInit(): void {
    this.fetchOrganizations();
  }

  fetchOrganizations() {
    this.organizationsService.fetchOrganizations()
    .subscribe({
      next: (response: any) => {
        this.organizations = response;

        console.log(this.organizations);
        this.organizations$ = of(this.organizations);
        this.filteredOrganizations$ = combineLatest([this.organizations$, this.filterValue$]).pipe(
          map(([organizations, filterValue]) => {
            return organizations.filter(organization => organization.name.toLowerCase().includes(filterValue.toLowerCase()))
          })
        );
          },
      error: (error:any) => {
        console.log(error);
        if (error.status === 401) {
          this.router.navigate(['/login']);
        }
      }
    });
  }

  createOrganization() {
  }

  onSubmit() {

  }

}
